import { callAPI } from "../config/AxiosTemplate";

import { API_RESPONSE_STATUS_CODES, API } from "../Utils/Constants";

export const changePasswordAction = (oldPassword, newPassword, callback) => {
  let data = {
    oldPassword: oldPassword,
    newPassword: newPassword,
  };
  callAPI("ChangePassword", API.changePassword, "POST", data, (apiResponse) => {
    if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      callback(apiResponse.data);
    } else {
      callback(apiResponse.data.status, null);
    }
  });
};
